import { useCallback, useState } from "react";

import { user as dummyUserImg } from "../../../helpers/images";
import { Content } from "../../../components/dashboard/ResizableShape";
import useBannerCSS from "../../../utils/hooks/useBannerCSS";

const RichTextPreview = ({ html, label }) => {
  function createText() {
    return { __html: html };
  }

  return (
    <div className="mb-4">
      <p className="contents text-sm font-medium text-gray-400 uppercase">
        {label}
      </p>

      <div
        className="text-base text-gray-900"
        dangerouslySetInnerHTML={createText()}
      />
    </div>
  );
};
const PreviewAndPublish = ({ formData }) => {
  const [bannerEl, setBannerEL] = useState(null);

  const bannerRef = useCallback((node) => {
    if (node !== null) {
      setBannerEL(node);
    }
  }, []);

  const { avatarCSS, usernameCSS } = useBannerCSS(bannerEl, {
    ...formData,
    nameAttribute: {
      ...formData.nameAttribute,
      fontFamily: formData.nameAttribute.fontFamily.value,
      fontSize: Number(formData.nameAttribute.fontSize.value),
    },
  });
  return (
    <div className="w-full mt-2 relative max-w-[703px]">
      <img
        ref={bannerRef}
        className="w-full h-full overflow-hidden relative"
        src={formData.bannerData}
        alt="Preview"
      />
      <img
        style={avatarCSS}
        src={dummyUserImg}
        className={`absolute z-40 ${
          formData.imageAttribute.shape.toLocaleLowerCase() === "circle"
            ? "rounded-full"
            : "rounded-sm"
        }`}
        alt="where user's face will be"
      />

      {!Boolean(formData?.hideUsername) && (
        <Content
          className="absolute z-40"
          style={{
            ...usernameCSS,
            fontStyle: formData.nameAttribute?.fontStyle,
            fontWeight: formData.nameAttribute?.fontWeight,
            justifyContent:
              formData.nameAttribute?.textAlign === "rpad"
                ? "flex-end"
                : formData.nameAttribute?.textAlign === "lpad"
                ? "flex-start"
                : "center",
            color: formData.nameAttribute?.textColor,
            textTransform: formData.nameAttribute?.textTransform,
          }}
        >
          {formData.sampleUsername.trim() || "Sample Name"}
        </Content>
      )}
      {formData.description ? (
        <RichTextPreview html={formData.description} label="Description" />
      ) : null}
    </div>
  );
};

export default PreviewAndPublish;
